export const toRedirectPath = (
  redirect: string | string[] | undefined
): string | null => {
  const path = Array.isArray(redirect) ? redirect[0] : redirect
  if (!path) {
    return null
  }
  return path.startsWith('/') ? path : `/${path}`
}
